import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useBreadcrumb } from "../../../context/breadcrumb";
import { BreadcrumbActionType } from "../../../context/breadcrumb/reducer";
import VuiHelmet from "../../../components/helmet";
import InoviceFormModule from "../../../modules/invoice/form";

const InoviceFormPage = () => {
  const { t } = useTranslation();
  const { dispatch } = useBreadcrumb();
  const { id } = useParams();
  const metaTitle = id
    ? t("pages.invoice.detail.metaTitle")
    : t("pages.invoice.request.metaTitle");

  useEffect(() => {
    dispatch({
      type: BreadcrumbActionType.Update,
      payload: [
        {
          link: "/",
          title: t("common.text.home"),
        },
        {
          link: "/invoice",
          title: t("common.text.invoice"),
        },
        {
          link: `/invoice/${id || "add"}`,
          title: id ? t("common.text.edit") : t("common.text.request"),
          isDisabled: true,
        },
      ],
    });
  }, [dispatch, t, id]);

  return (
    <>
      <VuiHelmet title={metaTitle} />

      <InoviceFormModule />
    </>
  );
};

export default InoviceFormPage;
